
export const getShopInfo = (state) => state.shopInfo

export const getAuthUser = (state) => state.authUser

export const getCart = (state) => state.cart;

export const getCheckoutInfo = (state) => state.checkoutInfo;